import { DeleteObjectCommand, DeleteObjectsCommand, DeleteObjectsCommandInput, GetObjectCommand, ListObjectVersionsCommand, ObjectIdentifier, S3Client } from '@aws-sdk/client-s3';
import { HttpRequest } from '@aws-sdk/protocol-http';
import { getSignedUrl, S3RequestPresigner } from '@aws-sdk/s3-request-presigner';
import { parseUrl } from '@aws-sdk/url-parser';
import { formatUrl } from '@aws-sdk/util-format-url';
import { t } from 'i18next';
import { SdnOperationType, useCreateSdnOperationMutation } from '../../../services/sdn';

export function downloadFile(client: S3Client, bucketname: string, name: string) {
    bucketname && createPreSignUrl(client, bucketname, name).then((link) => {
        const a = document.createElement('a');
        a.href = link;
        a.target = '_blank';
        a.download = name.split('/').pop() || 'file'; // Use the original filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(link); // Clean up the temporary URL
    }).catch((e) => console.error(e))

    // const input = {
    //     Bucket: bucketname,
    //     Key: name
    // };
    // const command = new GetObjectCommand(input);
    // client.send(command).then((r) => {
    //     // console.log(r);
    //     const stream = r.Body?.transformToWebStream();
    //     const rs = new Response(stream);
    //     rs.blob().then((m) => saveAs(m, name));
    // }).catch((e) => console.error(e));
}

export async function deleteFile(client: S3Client, bucketname: string, name: string, confirmed?: boolean) {
    const ret = confirmed || confirm(`${t('Delete')} ${name}?`);
    if (ret) {
        if (name.endsWith('/')) {
            const command2 = new ListObjectVersionsCommand({ Bucket: bucketname, Prefix: name });
            return client.send(command2).then((fff) => {
                if (fff.Versions) {
                    const input: DeleteObjectsCommandInput = {
                        Bucket: bucketname,
                        ChecksumAlgorithm: 'SHA1',
                        Delete: {
                            Objects: fff.Versions as ObjectIdentifier[],
                        },
                    }
                    const command = new DeleteObjectsCommand(input);
                    return client.send(command)
                }
                return Promise.reject({ name: 'Ошибка', message: 'Вероятно объект уже удален' });
            });
        } else {
            const input = {
                Bucket: bucketname,
                Key: name
            };
            const command = new DeleteObjectCommand(input);
            return client.send(command);
        }
    }
}

export async function deleteFiles(client: S3Client, bucketname: string, names: string[]) {
    const tasks = names.map((name) => deleteFile(client, bucketname, name, true));
    return Promise.all(tasks);
}

export function useMoveFileOperation(bucketname: string, src: string, dst: string, timeout?: number) {
    const [createOperation] = useCreateSdnOperationMutation();

    const srcPath = `${bucketname}/${src}`;
    return createOperation({
        command: SdnOperationType.MOVE,
        source: srcPath,
        destination: `${bucketname}/${dst}`,
        patterns: [],
        timeout: timeout || 600,
    });
}


export const createPreSignUrl = async (client: S3Client, bucketname: string, name: string, expiresIn?: number) => {
    const input = {
        Bucket: bucketname,
        Key: name,
        ResponseContentDisposition: 'attachment',
    };
    const command = new GetObjectCommand(input);

    async function generatePresignedUrl() {
        try {
            const url = await getSignedUrl(client, command, { expiresIn: expiresIn || 3600 }); // URL expires in 1 hour (3600 seconds)
            console.log('Presigned URL:', url);
            return url;
        } catch (error) {
            console.error('Error generating presigned URL:', error);
            throw error;
        }
    }

    return await generatePresignedUrl();
}

export const createPreSignUrlWithParams = async (client: S3Client, bucketname: string, name: string, params: Record<string, string>) => {
    async function generatePresignedUrl() {
        try {
            const endpoint =  client.config.endpoint && await client.config.endpoint();
            console.log(endpoint)
            const s3ObjectUrl = parseUrl(
                `${endpoint?.protocol}//${endpoint?.hostname}:${endpoint?.port}${endpoint?.path}${bucketname}/${name}`
            );
            s3ObjectUrl.query = params;
            const signer = new S3RequestPresigner({
                ...client.config
            });
            const presigned = await signer.presign(new HttpRequest(s3ObjectUrl));
            console.log('Presigned URL:', presigned);

            return formatUrl(presigned);
        } catch (error) {
            console.error('Error generating presigned URL:', error);
            throw error;
        }
    }

    return await generatePresignedUrl();
}